import styled, { css } from "styled-components";
import palette from "../../../lib/styles/palette";

import React from "react";
import AlertLabel from "../../common/AlertLabel";


const ModalOpenButton = ({ isActive=true, onClick, label, message, children }) => {

    return (
        <ModalOpenButtonBlock>
            <Button onClick={onClick} disabled={!isActive} isActive={isActive}>
                {children}
            </Button>
            <AlertLabel label={label} message={message} />
        </ModalOpenButtonBlock>
    );
};

export default ModalOpenButton;

const ModalOpenButtonBlock = styled.div`
    display: flex;
    margin-left: 0.7rem;
    margin-top: 1rem;
    margin-bottom: -1rem;
    `;
    
const Button = styled.button`
    padding: 0.4rem 2rem;
    border: none;
    outline: none;
    border-radius: 4px;

    font-weight: 600;
    font-size: 1rem;
    color: ${palette.orange};
    
    ${(props) => props.isActive && 
        css`
            background-color: ${palette.orange};
            color: #fff;
            font-weight: 600;

            &:hover {
                cursor: pointer
            }
        `
    }
`